import { render, staticRenderFns } from "./PriceRuleList.vue?vue&type=template&id=78f272ed&"
import script from "./PriceRuleList.vue?vue&type=script&lang=js&"
export * from "./PriceRuleList.vue?vue&type=script&lang=js&"
import style0 from "./PriceRuleList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports